import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CertificationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Certification",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.16 18.07c.47-.56.84-1.31.84-2.05-.09-.75-.37-1.49-.84-2.05-.19-.28-.37-.56-.47-.84 0-.37 0-.65.09-1.03.19-.75.19-1.49-.09-2.15-.37-.65-.93-1.12-1.68-1.4-.28-.09-.56-.37-.84-.56-.19-.28-.28-.56-.37-.93-.09-.75-.47-1.4-1.03-1.96-.65-.37-1.4-.65-2.05-.56-.37 0-.75-.09-1.03-.19-.28-.19-.47-.47-.65-.75-.47-.65-1.03-1.12-1.77-1.31-.75-.09-1.49 0-2.15.37-.28.19-.65.28-1.03.37-.37-.09-.65-.19-1.03-.28-.65-.37-1.4-.47-2.15-.37-.75.19-1.31.65-1.77 1.31-.19.28-.47.47-.75.65-.37.09-.75.09-1.03.09-.75 0-1.49.19-2.05.56-.65.56-.93 1.21-1.12 1.96-.09.37-.19.65-.37.93-.19.19-.47.37-.84.56-.65.28-1.31.84-1.68 1.49-.28.65-.28 1.4-.09 2.15.09.37.09.65.09 1.03-.09.37-.28.65-.47.84A2.9 2.9 0 0 0 1.99 16c.09.75.37 1.49.84 2.05.19.28.37.56.47.84 0 .37 0 .65-.09 1.03-.19.75-.19 1.49.09 2.15.37.65.93 1.12 1.68 1.4.28.09.56.37.84.56.19.28.28.56.37.93.09.75.47 1.4 1.03 1.96.65.37 1.4.65 2.05.56.37 0 .65 0 1.03.19.28.19.56.47.75.65.47.65 1.03 1.12 1.77 1.31.75.09 1.49 0 2.15-.37.28-.19.65-.28 1.03-.28.37.09.65.19 1.03.28.56.28 1.12.37 1.68.47.19 0 .28 0 .47-.09.75-.19 1.31-.65 1.77-1.31.19-.28.47-.47.75-.65.37-.09.65-.19 1.03-.19.75 0 1.49-.19 2.05-.56.56-.56.93-1.21 1.03-1.96.09-.37.19-.65.37-.93.28-.19.56-.47.84-.56.65-.28 1.31-.75 1.68-1.4.28-.65.28-1.49.09-2.15-.09-.37-.09-.65-.09-1.03.09-.28.28-.56.47-.84ZM16 26.75c-5.88 0-10.73-4.76-10.73-10.73S10.12 5.38 16 5.38s10.73 4.76 10.73 10.73c0 5.88-4.85 10.64-10.73 10.64m8.59-10.73c0 4.74-3.84 8.59-8.59 8.59s-8.59-3.84-8.59-8.59S11.25 7.43 16 7.43s8.59 3.84 8.59 8.59"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.68 15.36c-.3 0-.59-.12-.81-.33l-3.16-3.16a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l2.32 2.32 4.17-4.54c.43-.46 1.15-.5 1.61-.07.47.43.5 1.15.07 1.62L16.53 15c-.21.23-.51.36-.82.37h-.02Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.29 22.71c-6.3 0-11.43-5.13-11.43-11.43S9.98-.14 16.29-.14s11.43 5.13 11.43 11.43-5.13 11.43-11.43 11.43Zm0-20.57c-5.04 0-9.14 4.1-9.14 9.14s4.1 9.14 9.14 9.14 9.14-4.1 9.14-9.14-4.1-9.14-9.14-9.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.14 31.86q-.3 0-.57-.15l-6.29-3.63-6.29 3.63c-.35.2-.79.2-1.14 0s-.57-.58-.57-.99V18.96a1.14 1.14 0 1 1 2.28 0v9.79l5.14-2.97c.35-.2.79-.2 1.14 0l5.14 2.97v-9.78a1.14 1.14 0 1 1 2.28 0v11.76c0 .41-.22.79-.57.99q-.27.15-.57.15Z"
      })]
    })
  }));
};